module.exports = __webpack_public_path__ + "img/service_cloud_6.3211e601.jpg";